import type { ExtractPropTypes, StyleValue } from 'vue'
import { definePropType, buildProps } from '@sgui-plus/utils/props'
import type PageStatus from './page-status.vue'

export const pageStatusProps = buildProps({
  theme: {
    type: String,
    values: ['blue', 'green', 'complementary', 'warm'],
    default: 'blue',
  },
  type: {
    type: String,
    values: ['404', 'dataload', 'mistakes', 'nocontent', '500', 'nodata', 'pageerror'],
    default: 'dataload',
  },
  description: {
    type: String,
    default: ''
  },
  image: {
    type: String,
    default: '',
  },
  imageStyle: {
    type: definePropType<StyleValue>([String, Array, Object]),
    default: ''
  },
} as const)
export type PageStatusProps = ExtractPropTypes<typeof pageStatusProps>

export type PageStatusInstance = InstanceType<typeof PageStatus>
